module.exports = __webpack_public_path__ + "sidebar-bg.png?4380463d83015c44aa1b88264bcd15ca";